module.exports = __webpack_public_path__ + "4f7e7c0774fe86d07c6c03f78feeb83c.jpg";